export enum ObjectState {
  Pending = 0,
  Active = 1,
  Deleted = 2,
  Locked = 3,
}
